// Add your custom JS here.
( function( $ ) {




    var lastScrollTop = 0;

    $(window).on("scroll", function () {
        var st = $(this).scrollTop();

        // Add/remove 'down' class based on scroll direction
        if (st > lastScrollTop) {
            $('.site-header').addClass('down');
        } else {
            $('.site-header').removeClass('down');
        }
        lastScrollTop = st;

        // Add/remove 'scrolled' class based on scroll position
        if (st > 56) {
            $('.site-header').addClass('scrolled');
        } else {
            $('.site-header').removeClass('scrolled');
        }
    });



    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {
        var hash = this.hash;

        // Same-page anchor: scroll directly
        if (this.pathname === window.location.pathname && hash) {
            e.preventDefault();

            var target = $(hash);
            if (target.length) {
                // Snap all pending GSAP animations to their end state so the
                // layout is fully settled before we measure the target position
                gsap.utils.toArray('.fade-in-up, .fade-title-in .word').forEach(function(el) {
                    gsap.getTweensOf(el).forEach(function(tween) {
                        tween.progress(1, false);
                    });
                });
                ScrollTrigger.getAll().forEach(function(st) {
                    st.animation && st.animation.progress(1, false);
                });
                ScrollTrigger.refresh();

                setTimeout(function() {
                    $('html').css('scroll-behavior', 'auto');
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 800, function() {
                        $('html').css('scroll-behavior', 'smooth');
                    });
                }, 50);
            }

        // Cross-page anchor (e.g. from header to homepage#section):
        // store the hash so we can scroll after GSAP is ready on the new page
        } else if (hash) {
            try {
                sessionStorage.setItem('scrollToHash', hash);
            } catch(err) {}
        }
    });

    // Handle arriving on a page with a stored hash (cross-page anchor link)
    // or a hash directly in the URL (e.g. typed / refreshed)
    var pendingHash = null;
    try {
        pendingHash = sessionStorage.getItem('scrollToHash');
        sessionStorage.removeItem('scrollToHash');
    } catch(err) {}

    // Fall back to the URL hash if nothing was stored
    if (!pendingHash && window.location.hash) {
        pendingHash = window.location.hash;
    }

    if (pendingHash) {
        var $hashTarget = $(pendingHash);
        if ($hashTarget.length) {
            // Kill the browser's native scroll-to-anchor before it fires
            $('html').css('scroll-behavior', 'auto');
            window.scrollTo(0, 0);

            // Wait for GSAP ScrollTrigger tweens to be registered (they run
            // synchronously in the jQuery ready block, so a single rAF is enough),
            // then snap every tween to its final state and scroll.
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    ScrollTrigger.getAll().forEach(function(st) {
                        st.animation && st.animation.progress(1, false);
                    });
                    gsap.utils.toArray('.fade-in-up, .fade-title-in .word').forEach(function(el) {
                        gsap.set(el, { opacity: 1, y: 0 });
                    });
                    ScrollTrigger.refresh();

                    // Extra tick so the refresh has time to recalculate positions
                    requestAnimationFrame(function() {
                        $('html, body').animate({
                            scrollTop: $hashTarget.offset().top
                        }, 600, function() {
                            $('html').css('scroll-behavior', 'smooth');
                        });
                    });
                });
            });
        }
    }















    // Vertical Swiper Configuration
    const verticalSwiper = new Swiper('.vertical-swiper', {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        speed: 600,
        // No navigation or pagination
        navigation: false,
        pagination: false,
    });








    // Select the iframe
    const iframe = document.getElementById('vimeoplayer');

    if (iframe) {
        // Initialize the Vimeo Player
        const player = new Vimeo.Player(iframe);

        // Play button click handler
        $(".playbutton").on("click", function () {
            player.play();
            $(".video-popup").addClass("active");
        });

        // Close button click handler
        $(".video-popup .close").on("click", function () {
            player.pause();
            $(".video-popup").removeClass("active");
        });
    } 





    $(".close-popup").on("click", function () {
        $(this).parent().fadeOut(150);
    });




    $(".insurance-popup i").on("click", function () {
        $(this).parent().addClass("hide");
    });




    $(".quote-btn").on("click", function () {
        $(".request-popup").addClass("active");
    });

    $(".request-popup .close").on("click", function () {
        $(".request-popup").removeClass("active");
    });




    $(".backdrop").on("click", function () {
        $(".main-menu, .backdrop, .dropdown-container, .menu-icon").removeClass("active");
    });


    $(".backdrop").on("click", function () {
        $(".primary-navigation, .backdrop, .menu-toggle").removeClass("active");
    });


    $(".site-header__mobile-toggle").on("click", function () {
        $(".site-header").toggleClass("active");
    });

    // Mobile sub-menu dropdown toggle
    // Clicking the arrow toggles the dropdown, clicking the parent link navigates
    $(".sub-menu-toggle").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $parentLi = $(this).parent("li");
        $parentLi.toggleClass("sub-menu-open");
        $(this).attr("aria-expanded", $parentLi.hasClass("sub-menu-open"));
    });

    // On mobile, prevent the parent li click from toggling the dropdown
    // (the flex container li was intercepting clicks before)
    $(".menu-item-has-children > a").on("click", function (e) {
        // On mobile, let the link navigate normally (don't prevent default)
        // The sub-menu-toggle handles the dropdown separately
    });

    
    ////////////// GSAP STUFFFFFF////////////// GSAP STUFFFFFF////////////// GSAP STUFFFFFF
    // ScrollTrigger.normalizeScroll(true);









// Select all headings within .fade-title-in
const headings = document.querySelectorAll('.fade-title-in h1, .fade-title-in h2, .fade-title-in h3, .fade-title-in h4, .fade-title-in h5, .fade-title-in h6');

headings.forEach((heading) => {
    // Function to wrap words in text nodes only, preserving all HTML
    function wrapWordsInTextNodes(element) {
        // Create a TreeWalker to find all text nodes
        const walker = document.createTreeWalker(
            element,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    // Only process text nodes that contain non-whitespace content
                    return node.textContent.trim().length > 0 ? 
                        NodeFilter.FILTER_ACCEPT : 
                        NodeFilter.FILTER_REJECT;
                }
            }
        );

        const textNodes = [];
        let node;
        
        // Collect all text nodes first (to avoid modifying while iterating)
        while (node = walker.nextNode()) {
            textNodes.push(node);
        }

        // Process each text node
        textNodes.forEach(textNode => {
            const text = textNode.textContent;
            
            // Skip if the text node only contains whitespace
            if (!text.trim()) return;
            
            // Split text into words, preserving spaces
            const parts = text.split(/(\s+)/);
            
            // Create a document fragment to hold the new elements
            const fragment = document.createDocumentFragment();
            
            parts.forEach(part => {
                if (part.trim()) {
                    // This is a word - wrap it
                    const wordWrapper = document.createElement('span');
                    wordWrapper.className = 'word-wrapper';
                    
                    const wordSpan = document.createElement('span');
                    wordSpan.className = 'word';
                    wordSpan.textContent = part;
                    
                    wordWrapper.appendChild(wordSpan);
                    fragment.appendChild(wordWrapper);
                } else {
                    // This is whitespace - preserve it as text node
                    const spaceNode = document.createTextNode(part);
                    fragment.appendChild(spaceNode);
                }
            });
            
            // Replace the original text node with our wrapped version
            textNode.parentNode.replaceChild(fragment, textNode);
        });
    }

    // Apply the word wrapping to this heading
    wrapWordsInTextNodes(heading);
    
    // Add CSS to ensure proper display
    const style = document.createElement('style');
    if (!document.querySelector('#word-wrapper-styles')) {
        style.id = 'word-wrapper-styles';
        style.textContent = `
            .word-wrapper {
                display: inline-block;
                overflow: hidden;
            }
            .word {
                display: inline-block;
                transform: translateY(0);
            }
        `;
        document.head.appendChild(style);
    }
    
    // Animate the words on scroll
    gsap.fromTo(
        heading.querySelectorAll('.word'),
        { 
            y: '100%', 
            opacity: 0 
        },
        {
            y: '0%',
            opacity: 1,
            stagger: 0.05,
            duration: 0.6,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: heading,
                start: 'top 80%',
                end: 'bottom 20%',
                toggleActions: 'play none none none',
            },
        }
    );
});

// Alternative simpler version if you want to be extra safe
// This version is more conservative and handles edge cases better
function robustWordWrapper(headings) {
    headings.forEach((heading) => {
        // Store original content for fallback
        const originalContent = heading.innerHTML;
        
        try {
            // Create a temporary container to work with
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = originalContent;
            
            // Function to recursively process nodes
            function processNode(node) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent;
                    if (text.trim()) {
                        // Split into words and spaces
                        const words = text.split(/(\s+)/);
                        const fragment = document.createDocumentFragment();
                        
                        words.forEach(word => {
                            if (word.trim()) {
                                // Create word wrapper
                                const wrapper = document.createElement('span');
                                wrapper.className = 'word-wrapper';
                                const span = document.createElement('span');
                                span.className = 'word';
                                span.textContent = word;
                                wrapper.appendChild(span);
                                fragment.appendChild(wrapper);
                            } else {
                                // Preserve whitespace
                                fragment.appendChild(document.createTextNode(word));
                            }
                        });
                        
                        return fragment;
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    // Process child nodes
                    const children = Array.from(node.childNodes);
                    children.forEach(child => {
                        const processed = processNode(child);
                        if (processed) {
                            node.replaceChild(processed, child);
                        }
                    });
                }
                return node;
            }
            
            // Process all nodes in the temporary container
            Array.from(tempDiv.childNodes).forEach(child => {
                processNode(child);
            });
            
            // Replace the heading content
            heading.innerHTML = tempDiv.innerHTML;
            
        } catch (error) {
            // Fallback: restore original content if anything goes wrong
            console.warn('Word wrapping failed, using original content:', error);
            heading.innerHTML = originalContent;
            return; // Skip animation for this heading
        }
        
        // Animate the words
        gsap.fromTo(
            heading.querySelectorAll('.word'),
            { y: '100%', opacity: 0 },
            {
                y: '0%',
                opacity: 1,
                stagger: 0.05,
                duration: 0.6,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: heading,
                    start: 'top 80%',
                    end: 'bottom 20%',
                    toggleActions: 'play none none none',
                },
            }
        );
    });
}









    // Select all media items
    const mediaItems = document.querySelectorAll(".parallax>img, .parallax>video, .parallax>iframe, .parallax>svg");

    mediaItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 50 }, // Start slightly down
            {
                y: -50, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });









    // Select all media items
    const mparItems = document.querySelectorAll(".parall");

    mparItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 100 }, // Start slightly down
            {
                y: -100, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });












gsap.registerPlugin(ScrollTrigger);

// 1) Init (bind once per element)
function initFadeIns(root = document) {
  gsap.utils.toArray(".fade-in-up", root).forEach(el => {
    if (el.dataset.stBound) return;
    el.dataset.stBound = "1";

    gsap.from(el, {
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    });
  });
}

initFadeIns();

// 2) Call this after your AJAX injects content
function notifyLayoutChange(container) {
  if (container) initFadeIns(container);
  ScrollTrigger.refresh();
}

// 3) Debounced refresh for late-loading images only
const debouncedRefresh = (() => {
  let t; 
  return () => { clearTimeout(t); t = setTimeout(() => ScrollTrigger.refresh(), 300); };
})();

// Only watch for image load events, not ResizeObserver on body
document.querySelectorAll("img").forEach(img => {
  if (!img.complete) img.addEventListener("load", debouncedRefresh, { once: true });
});












    

    // Function to animate countup elements
    if ($('.countup').length) {
        function initCountUp() {
        const countupElements = gsap.utils.toArray('.countup');
        
        countupElements.forEach(element => {
            // Get the original text content
            const originalText = element.textContent.trim();
            
            // Parse the text to extract number and any prefix/suffix
            const match = originalText.match(/^([^0-9]*)(\d+)(.*)$/);
            
            if (!match) return; // Skip if no number found
            
            const prefix = match[1]; // + or -
            const number = parseInt(match[2]);
            const suffix = match[3]; // % or other characters
            
            // Set initial value to 0
            element.textContent = prefix + '0' + suffix;
            
            // Create the animation
            const countUpAnimation = gsap.to(element, {
            duration: 2,
            ease: "power1.out",
            onUpdate: function() {
                const progress = this.progress();
                const currentValue = Math.round(number * progress);
                element.textContent = prefix + currentValue + suffix;
            },
            scrollTrigger: {
                trigger: element,
                start: "top 80%", // Start when element is 80% from top of viewport
                once: true, // Only animate once
            }
            });
        });
        }

        // Initialize on page load
        document.addEventListener('DOMContentLoaded', initCountUp);
    }










    /**
     * Video Modal Functionality - Vimeo Only Version
     */
    function initVideoModals() {
        // Get the modal elements
        const videoModal = document.getElementById('video-modal');
        const videoModalClose = document.getElementById('video-modal-close');
        const videoModalIframeContainer = document.getElementById('video-modal-iframe-container');
        
        if (!videoModal) return; // Exit if modal doesn't exist
        
        // Get all play buttons
        const videoPlayButtons = document.querySelectorAll('.video-play-button');
        
        // Add click event to all play buttons
        videoPlayButtons.forEach(button => {
            button.addEventListener('click', function() {
                const videoId = this.getAttribute('data-video-id');
                const videoUrl = this.getAttribute('data-video-url');
                
                // Create iframe
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', videoUrl);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', 'true');
                iframe.setAttribute('allow', 'autoplay; fullscreen');
                iframe.setAttribute('id', 'video-iframe-' + videoId);
                
                // Clear existing iframe and add new one
                videoModalIframeContainer.innerHTML = '';
                videoModalIframeContainer.appendChild(iframe);
                
                // Open modal
                videoModal.classList.add('active');
                
                // Prevent scrolling on body
                document.body.style.overflow = 'hidden';
            });
        });
        
        // Close modal when clicking the close button
        videoModalClose.addEventListener('click', closeModal);
        
        // Close modal when clicking outside the content
        videoModal.addEventListener('click', function(event) {
            if (event.target === videoModal) {
                closeModal();
            }
        });
        
        // Close modal with ESC key
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && videoModal.classList.contains('active')) {
                closeModal();
            }
        });
        
        function closeModal() {
            // Remove active class
            videoModal.classList.remove('active');
            
            // Empty iframe container to stop video
            videoModalIframeContainer.innerHTML = '';
            
            // Restore scrolling
            document.body.style.overflow = '';
        }
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', initVideoModals);




    /**
     * Blog Overview "Load more"
     * Reveals the next batch of hidden cards on each click; hides the
     * button once everything is visible.
     */
    $('.blog-overview').each(function () {
        var $section = $(this);
        var $grid = $section.find('[data-blog-overview]');
        var $button = $section.find('[data-blog-load-more]');

        if (!$grid.length || !$button.length) {
            return;
        }

        var batchSize = parseInt($grid.attr('data-batch-size'), 10) || 9;

        $button.on('click', function () {
            var $hidden = $grid.find('.blog-overview__card--hidden');

            $hidden.slice(0, batchSize).removeClass('blog-overview__card--hidden');

            // Nothing left to reveal -> remove the button.
            if ($grid.find('.blog-overview__card--hidden').length === 0) {
                $button.closest('.blog-overview__load-more-wrap').remove();
            }

            // Newly revealed cards may carry fade-in animations / images.
            if (typeof notifyLayoutChange === 'function') {
                notifyLayoutChange($grid.get(0));
            }
        });
    });

    /**
     * Populate Gravity Forms favorites/wensenlijst fields from localStorage.
     */
    var DecoratieFavorites = {
        key: 'decoratie_favorites',

        getTitles: function () {
            try {
                var favorites = JSON.parse(localStorage.getItem(this.key)) || {};
                return Object.values(favorites).map(function (favorite) {
                    return favorite.title;
                }).filter(function (title) {
                    return title;
                });
            } catch (e) {
                return [];
            }
        }
    };

    function getWensenlijstConsentInput($form) {
        var $consentInput = null;

        $form.find('.gfield').each(function () {
            var $field = $(this);
            var fieldText = $field.find('.gfield_label, .gfield_consent_label, .gfield_consent_description, label').text().toLowerCase();

            if (fieldText.indexOf('wensenlijst') !== -1) {
                $consentInput = $field.find('input[type="checkbox"]').first();
                return false;
            }
        });

        return $consentInput;
    }

    function populateGravityFormFavorites(formId) {
        var $form = $('#gform_' + formId);

        if (!$form.length) {
            return;
        }

        var $favoritesField = $form.find('.gfield.favorites textarea, .gfield.favorites input[type="text"]').first();

        if (!$favoritesField.length) {
            return;
        }

        var $wensenlijstConsent = getWensenlijstConsentInput($form);

        if ($wensenlijstConsent && !$wensenlijstConsent.is(':checked')) {
            $favoritesField.val('');
            return;
        }

        var favoriteTitles = DecoratieFavorites.getTitles();

        if (favoriteTitles.length > 0) {
            $favoritesField.val(favoriteTitles.join(', '));
        } else if ($wensenlijstConsent) {
            $favoritesField.val('Geen favorieten geselecteerd');
        } else {
            $favoritesField.val('');
        }
    }

    function bindGravityFormFavorites(formId) {
        populateGravityFormFavorites(formId);

        var $form = $('#gform_' + formId);

        // Update the hidden favorites field the moment the consent checkbox is toggled.
        var $wensenlijstConsent = getWensenlijstConsentInput($form);
        if ($wensenlijstConsent && $wensenlijstConsent.length) {
            $wensenlijstConsent
                .off('change.basmaFavorites')
                .on('change.basmaFavorites', function () {
                    populateGravityFormFavorites(formId);
                });
        }

        // Fallback: make sure the field is current right before submit.
        $form
            .off('submit.basmaFavorites')
            .on('submit.basmaFavorites', function () {
                populateGravityFormFavorites(formId);
            });

        $(document).off('gform_pre_submission_' + formId + '.basmaFavorites');
        $(document).on('gform_pre_submission_' + formId + '.basmaFavorites', function () {
            populateGravityFormFavorites(formId);
        });
    }

    $(document).on('gform_post_render', function (event, formId) {
        if ($('#gform_' + formId).find('.gfield.favorites').length) {
            bindGravityFormFavorites(formId);
        }
    });

    // Bind for forms already rendered (non-AJAX page loads)
    $('form[id^="gform_"]').each(function () {
        var formId = ($(this).attr('id') || '').replace('gform_', '');
        if (formId && $(this).find('.gfield.favorites').length) {
            bindGravityFormFavorites(formId);
        }
    });

    $(document).on('favoritesChanged', function () {
        $('.gfield.favorites').each(function () {
            var $form = $(this).closest('form');
            var formId = ($form.attr('id') || '').replace('gform_', '');

            if (formId) {
                populateGravityFormFavorites(formId);
            }
        });
    });












    // Services section: grid on desktop, Swiper slider on mobile.
    // Swiper is booted/destroyed on the breakpoint so the desktop grid keeps
    // its own layout and never inherits Swiper's slide sizing.
    (function servicesSectionSlider() {
        if (typeof Swiper === 'undefined') {
            return;
        }

        var sliders = Array.prototype.slice.call(
            document.querySelectorAll('.services-section__slider')
        );

        if (!sliders.length) {
            return;
        }

        var mobile = window.matchMedia('(max-width: 992px)');

        function enable(slider) {
            if (slider.servicesSwiper) {
                return;
            }

            var wrapper = slider.querySelector('.services-section__services-grid');
            var slides = slider.querySelectorAll('.services-section__service-item');

            // Nothing to slide through with a single card.
            if (!wrapper || slides.length < 2) {
                return;
            }

            slider.classList.add('swiper');
            wrapper.classList.add('swiper-wrapper');
            Array.prototype.forEach.call(slides, function (slide) {
                slide.classList.add('swiper-slide');
            });

            slider.servicesSwiper = new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                grabCursor: true,
                watchOverflow: true,
                navigation: {
                    prevEl: slider.querySelector('.services-section__slider-button--prev'),
                    nextEl: slider.querySelector('.services-section__slider-button--next')
                },
                pagination: {
                    el: slider.querySelector('.services-section__slider-pagination'),
                    clickable: true
                },
                breakpoints: {
                    576: { slidesPerView: 1.6, spaceBetween: 20 },
                    768: { slidesPerView: 2.2, spaceBetween: 24 }
                }
            });
        }

        function disable(slider) {
            if (!slider.servicesSwiper) {
                return;
            }

            slider.servicesSwiper.destroy(true, true);
            slider.servicesSwiper = null;

            slider.classList.remove('swiper');

            var wrapper = slider.querySelector('.services-section__services-grid');
            if (wrapper) {
                wrapper.classList.remove('swiper-wrapper');
            }

            Array.prototype.forEach.call(
                slider.querySelectorAll('.services-section__service-item'),
                function (slide) {
                    slide.classList.remove('swiper-slide');
                }
            );
        }

        function sync() {
            sliders.forEach(function (slider) {
                if (mobile.matches) {
                    enable(slider);
                } else {
                    disable(slider);
                }
            });
        }

        sync();

        if (typeof mobile.addEventListener === 'function') {
            mobile.addEventListener('change', sync);
        } else if (typeof mobile.addListener === 'function') {
            mobile.addListener(sync); // Safari < 14
        }
    })();


})(jQuery);

